<template>
    <v-dialog v-model="show" max-width="290" persistent>
        <v-card light>
            <v-card-text class="own-flex">
                <h5 class="green--text">{{ message }}</h5>
                <v-progress-circular indeterminate :size="60" color="green"></v-progress-circular>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'Loader',
    props: {
        show: { required: true, default: false },
        message: { default: 'Cargando datos...' }
    },
    data() {
        return {
            
        }
    }
}
</script>

<style lang="css" scoped>
    .own-flex {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
</style>


// WEBPACK FOOTER //
// src/components/helpers/modals/Loader.vue